import React from 'react';
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { compose } from "redux";
import { firebaseConnect, getVal } from 'react-redux-firebase';
import CaProfileHeroContainer from './CaProfileHeroContainer';
import CaProfileAwardsContainer from './CaProfileAwardsContainer';
import CaProfileCompletedQuizzesContainer from "./CaProfileCompletedQuizzesContainer";
import * as actionsAccountModal from '../../actions/accountModalActions';
import CaProfileScoreContainer from "./CaProfileScoreContainer";
import CaProfileBadgesContainer from "./CaProfileBadgesContainer";
import CaQuizToutContainer from "../general/CaQuizToutContainer";
import CaQuizzesBannerContainer from "../general/CaQuizzesBannerContainer";


class CaProfileContainer extends React.Component {

    constructor(props) {
        super(props);
    }

    getTier(points) {
        if (this.props.levelsData !== undefined) {
            const filteredLevelData =
                this.props.levelsData
                    .filter(level => parseInt(level.points) <= parseInt(points))
                    .sort((v1, v2) => (parseInt(v1.points) < parseInt(v2.points)))[0];
            return filteredLevelData;
        }
        return [];
    }

    getMaxPoints() {
        const { quizData } = this.props;
        if (quizData.length > 0) {
            const values = Object.values(quizData).map(item => item.question.filter(subitem => !subitem.is_free_text).length);
            return values.reduce((a, b) => (a + b));
        }

        return [];
    }

    hasCompletedAnyQuizzes() {
        const { userData } = this.props;
        return !!userData && Object.values(userData).length > 0;
    }

    getNotLoggedInView(text) {
        return (
            <div className={"ProfilePage"}>
                <div className={"ProfilePageNotLoggedIn"}>
                    <div className={"ProfilePageNotLoggedIn__inner"}>
                        <div className={"ProfilePageNotLoggedIn__content"}>
                            <h2>{text}</h2>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const { firebase, userData, profile, pageImage, quizData, generalData, auth, accountModal } = this.props;

        if (!accountModal.open && auth.isLoaded && auth.isEmpty) {
            window.location.href = "/";
            return this.getNotLoggedInView(this.props.t('not_logged_in'));
        }
        if (!accountModal.open && auth.isLoaded && firebase.auth().currentUser && firebase.auth().currentUser.isAnonymous) {
            window.location.href = "/";
            return this.getNotLoggedInView(this.props.t('not_logged_in'));
        }


        if (!auth.isLoaded || !profile.isLoaded) {
            return this.getNotLoggedInView(this.props.t('loading'));
        }

        let score = profile.score || 0;
        const tier = this.getTier(score);
        return (
            <div className={"ProfilePage"}>
                {
                    profile &&
                    <CaProfileHeroContainer backgroundImage={pageImage} tier={tier} score={score} maxPoints={this.getMaxPoints()} />
                }
                {!this.hasCompletedAnyQuizzes() &&
                    <CaQuizToutContainer />
                }
                {userData && this.hasCompletedAnyQuizzes() &&
                    <div>
                        <CaProfileScoreContainer userScore={score} maxUserScore={generalData.topScore} maxPoints={this.getMaxPoints()} />
                        <CaProfileBadgesContainer />
                        <CaProfileAwardsContainer tier={tier} />
                        <CaQuizzesBannerContainer cta={"See quizzes"} ctaCallback={() => { window.location.href = "/golden-club" }} />
                        <CaProfileCompletedQuizzesContainer quizData={quizData} userData={userData} />
                    </div>
                }
            </div>
        )
    }
}




export default compose(
    connect((state) => ({
        auth: state.firebase.auth,
        generalData: getVal(state.firebase, `data/general/`),
        userData: getVal(state.firebase, `data/quiz/${state.firebase.auth.uid}/`),
        profile: state.firebase.profile,
        accountModal: state.accountModalReducer,
        quiz: state.quiz
    }), Object.assign({}, actionsAccountModal)),
    firebaseConnect((props, store) => [
        `quiz/${store.getState().firebase.auth.uid}`,
        `general/`
    ]),
)(withTranslation("translations")(CaProfileContainer))




